import { connect } from 'react-redux'
import * as api from '../../../actions/api'
import * as actions from '../../../actions'
import { EventHistoryDialog } from '../components'

const mapStateToProps = (state, ownProps) => {
  var records
  const { language } = state.user
  records = state.history.records.filter(record => record.eventId === parseInt(ownProps.id, 10))
  return ({
    records,
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleEnter: () => {
      dispatch(api.event.selectHistory(ownProps.id, response => {
        dispatch(actions.history.responseSelectEventHistory(response))
      }))
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventHistoryDialog)


// WEBPACK FOOTER //
// ./src/Pages/Event/containers/EventHistoryDialog.js